import { useEffect, useState } from 'react';

import { logToSentry, useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { fetchExternalProductReviewsFromPartner } from '../services/fetchExternalProductReviewsFromPartner';
import { type ProductDetailContext, type ReviewsPartner } from '../types/types';
import { useProduct } from './useProduct';

type UseReviews = {
    reviews: ReviewsPartner | null;
};

export const useReviewsFromPartner = (): UseReviews => {
    const { productId } = useProduct();
    const { reviewPartnerAppKey } = useFragmentContext<ProductDetailContext>();

    const [reviews, setReviews] = useState<ReviewsPartner | null>(null);

    useEffect(() => {
        const fetchReviews = async () => {
            if (reviewPartnerAppKey && !reviews) {
                try {
                    const response = await fetchExternalProductReviewsFromPartner(
                        reviewPartnerAppKey,
                        productId,
                    );

                    if (response?.reviews?.length > 0) {
                        setReviews(response);
                    }
                } catch (error) {
                    logToSentry(error as Error);
                }
            }
        };

        fetchReviews();
    }, [productId, reviewPartnerAppKey, reviews]);

    return { reviews };
};
